export default (state = {}) => {
  return {
    ...state,
    autoLoginBiometrics: false,
  };
};
